import {
  Dashboard,
  Login,
  Otp,
  Register,
  Profile,
  Upload,
  BasicInformation,
  Setting,
  Transactions,
  VisaOrders,
  NewVisaOrder,
  Payment,
  FormNumberTwo,
  NewPassword,
  Crew,
  VisaHistory,
  NewCrew,
  OtpCrew,
  RegisterCrew,
  CrewNewPassword,
  LoginCrew,
  Unpaid,
  PayVisa, SuccessPay, FailedPay, CanceledVisas, ActiveVisas, SingleCrew
} from "../pages/index.js";


export const beforeAuthRoutes = {
  login: '/auth/login',
  otp: '/auth/otp',
  newPassword: '/auth/new-password/:email?/:code?',
  crewNewPassword: '/crew/auth/new-password/:email?/:code?',
  register: '/auth/register',
  loginCrew: '/crew/auth/login',
  otpCrew: '/crew/auth/otp',
  registerCrew: '/crew/auth/register/:id?',
};

export const afterAuthRoutes = {
  BasicInformationState: '/basic-information/state',
  BasicInformationCity: '/basic-information/city',
  BasicInformationJobs: '/basic-information/jobs',
  BasicInformationShip: '/basic-information/ship',
  BasicInformationVisa: '/basic-information/visa',
  BasicInformationWharf: '/basic-information/wharf',
  BasicInformationRole: '/basic-information/role',
  BasicInformationUser: '/basic-information/users',
  BasicInformationAirport: '/basic-information/airport',
  BasicInformationAirline: '/basic-information/airline',
  BasicInformationEmails: '/basic-information/emails',
  BasicInformationCountry: '/basic-information/country',
  BasicInformationNewUser: '/basic-information/user/new/:id?',
  BasicInformationJobLevels : '/basic-information/job-levels',
  BasicInformationShipType : '/basic-information/ship-type',
  BasicInformationDocuments : '/basic-information/document',
  setting: '/setting',
  crew: '/crew',
  visaOrders: '/visa-orders',
  visaForms: '/visa-orders/forms/:id?',
  visaHistory: '/crew/visa-history',
  editCrew: '/crew/new-crew/:id?',
  newCrew: '/crew/single',
  newVisaOrder: '/visa-orders/new-visa',
  transactions: '/transactions',
  dashboard: '/dashboard',
  profile: '/profile',
  upload: '/upload',
  payment: `/agent-visa/:id/:status/:followUp`,
  ReportsUnpaid: '/reports/unpaid',
  PayVisa: '/pay-visa',
  SuccessPay: '/success-pay',
  FailedPay: '/failed-pay',
  cancaledVisas: '/canceled-visas',
  activeVisas: '/active-visas'
};


export const routesMapping = [
  {
    route: afterAuthRoutes.dashboard,
    Element: <Dashboard />,
  },

  {
    route: "/",
    Element: <Dashboard />,
  },

  {
    route: afterAuthRoutes.BasicInformationState,
    Element: <BasicInformation />,
  },
  {
    route: afterAuthRoutes.BasicInformationCity,
    Element: <BasicInformation />,
  },
  {
    route: afterAuthRoutes.BasicInformationJobs,
    Element: <BasicInformation />,
  },
  {
    route: afterAuthRoutes.BasicInformationShip,
    Element: <BasicInformation />,
  },
  {
    route: afterAuthRoutes.BasicInformationVisa,
    Element: <BasicInformation />,
  },
  {
    route: afterAuthRoutes.BasicInformationWharf,
    Element: <BasicInformation />,
  },
  {
    route: afterAuthRoutes.BasicInformationCountry,
    Element: <BasicInformation />,
  },
  {
    route: afterAuthRoutes.visaForms,
    Element: <FormNumberTwo />,
  },
  {
    route: afterAuthRoutes.BasicInformationRole,
    Element: <BasicInformation />,
  },
  {
    route: afterAuthRoutes.BasicInformationUser,
    Element: <BasicInformation />,
  },
  {
    route: afterAuthRoutes.BasicInformationNewUser,
    Element: <BasicInformation />,
  },
  {
    route: afterAuthRoutes.BasicInformationAirport,
    Element: <BasicInformation />,
  },
  {
    route: afterAuthRoutes.BasicInformationAirline,
    Element: <BasicInformation />,
  },
  {
    route: afterAuthRoutes.BasicInformationEmails,
    Element: <BasicInformation />,
  },
  {
    route: afterAuthRoutes.BasicInformationJobLevels,
    Element: <BasicInformation />,
  },
  {
    route: afterAuthRoutes.BasicInformationShipType,
    Element: <BasicInformation />,
  },
  {
    route: afterAuthRoutes.BasicInformationDocuments,
    Element: <BasicInformation />,
  },
  {
    route: afterAuthRoutes.profile,
    Element: <Profile />,
  },

  {
    route: afterAuthRoutes.setting,
    Element: <Setting />,
  },
  {
    route: afterAuthRoutes.crew,
    Element: <Crew />,
  },
  {
    route: afterAuthRoutes.editCrew,
    Element: <NewCrew />,
  },
  {
    route: afterAuthRoutes.newCrew,
    Element: <SingleCrew />,
  },
  {
    route: afterAuthRoutes.payment,
    Element: <Payment />,
  },
  {
    route: afterAuthRoutes.visaHistory,
    Element: <VisaHistory />,
  },
  {
    route: afterAuthRoutes.transactions,
    Element: <Transactions />,
  },

  {
    route: afterAuthRoutes.visaOrders,
    Element: <VisaOrders />,
  },
  {
    route: afterAuthRoutes.newVisaOrder,
    Element: <NewVisaOrder />,
  },

  {
    route: afterAuthRoutes.upload,
    Element: <Upload />,
  },

  {
    route: beforeAuthRoutes.login,
    Element: <Login />,
  },

  {
    route: beforeAuthRoutes.otp,
    Element: <Otp />,
  },
  {
    route: beforeAuthRoutes.newPassword,
    Element: <NewPassword />,
  },
  {
    route: beforeAuthRoutes.crewNewPassword,
    Element: <CrewNewPassword />,
  },

  {
    route: beforeAuthRoutes.register,
    Element: <Register />,
  },
  {
    route: beforeAuthRoutes.loginCrew,
    Element: <LoginCrew />,
  },

  {
    route: beforeAuthRoutes.otpCrew,
    Element: <OtpCrew />,
  },

  {
    route: beforeAuthRoutes.registerCrew,
    Element: <RegisterCrew />,
  },
  {
    route: afterAuthRoutes.ReportsUnpaid,
    Element: <Unpaid />,
  },
  {
    route: afterAuthRoutes.PayVisa,
    Element: <PayVisa />,
  },
  {
    route: afterAuthRoutes.SuccessPay,
    Element: <SuccessPay />,
  },
  {
    route: afterAuthRoutes.FailedPay,
    Element: <FailedPay />,
  },
  {
    route: afterAuthRoutes.cancaledVisas,
    Element: <CanceledVisas />,
  },
  {
    route: afterAuthRoutes.activeVisas,
    Element: <ActiveVisas />
  }


];

const alwaysShowRoutes = ['/', '/test'];

const beforeAuth = [beforeAuthRoutes.login, beforeAuthRoutes.register, beforeAuthRoutes.otp, beforeAuthRoutes.loginCrew, beforeAuthRoutes.registerCrew, beforeAuthRoutes.otpCrew, beforeAuthRoutes.newPassword, beforeAuthRoutes.crewNewPassword];

export const filterRoutesByAuthStep = (isAuth) => {
  return routesMapping.filter((item) => {
    if (!isAuth) {
      if (beforeAuth.includes(item.route) || alwaysShowRoutes.includes(item.route)) {
        return item;
      }
    } else if (!beforeAuth.includes(item.route) || alwaysShowRoutes.includes(item.route)) {
      return item;
    }
  });
};
